module.exports = __webpack_public_path__ + "253f6feb4b81a20a6629733fc5d0aa13.svg";